import { _ as _object_without_properties_loose, a as _extends } from './cc-CWi2JB6O.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Suspense } from 'react';
import { cn, thumbhashDataURL } from '@repo/lib';
import { Image } from './image.js';
import { V as VideoClient } from './video-client-12s-C7oS3FGR.js';

function Video(_param) {
    var { className, id, preload, previewImage, title } = _param, props = _object_without_properties_loose(_param, [
        "className",
        "id",
        "preload",
        "previewImage",
        "title"
    ]);
    if (previewImage) {
        previewImage.thumbhash = undefined;
    }
    return /*#__PURE__*/ jsxs("figure", {
        className: cn(className, "relative h-full w-full"),
        id: id,
        children: [
            previewImage && /*#__PURE__*/ jsx(Image, _extends({}, previewImage, {
                blurDataURL: previewImage.thumbhash ? thumbhashDataURL(previewImage.thumbhash) : undefined,
                className: cn("absolute h-full object-cover", previewImage.className),
                preload: preload
            })),
            /*#__PURE__*/ jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ jsx(VideoClient, _extends({}, props, {
                    className: className
                }))
            }),
            title && /*#__PURE__*/ jsx("figcaption", {
                children: title
            })
        ]
    });
}

export { Video };
